import * as types from './mutation-types';

export default {
  [types.SET_LIST](state, list) {
    state.list = list;
  },
  [types.SET_ERRORS](state, errors) {
    state.errors = errors;
  }
};
